import { css, Theme } from '@emotion/react'

export const form = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: ${theme.spacing(2)};

  margin-top: ${theme.spacing(5)};
  width: 100%;
`

export const levelWrapper = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(3)};

  width: 100%;
`

export const levelSelect = css`
  flex: 1;
`

export const levelPreview = css`
  display: flex;
  flex-direction: column;
  flex: 1;

  row-gap: 10px;
`

export const levelPreviewTitle = (theme: Theme) => css`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: ${theme.typographyColors.typographyThree};
`

export const imagePreviewWrapper = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 17px;

  background-color: ${theme.colors.backgroundFive};
`

export const achievementImagePreviewWrapper = () => css`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const imagePreview = css`
  max-width: 45%;
`

export const formActions = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(3)};

  margin-top: ${theme.spacing(2)};
  width: 100%;
`

export const addButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};
`
